import React from 'react';
import AppLayout from '../../layouts/app/AppLayout';
import AppIcons from '../../assets/images/icons';
import './custom.scss';
import SVGIcons from '../../assets/images/icons/svgIcons';
import ContactForm from '../../components/contactForm/ContactForm';

import { translateThis } from '../../helpers/language.helper';
// import MapComponent from '../../components/mapElement';



const GlobalPresence = () => {
    // custom home functions here
    const pageName = "Global presence";

    const impactConList = [
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Enhancing access to quality education',
        },
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Promoting gender equality and inclusive practices',
        },
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Investing in teacher training and development',
        },
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Improving educational infrastructure and curriculum',
        }
    ];

    return (
        <AppLayout
            pageName={pageName}
        >

            <div className="main-content-wrapper globalPresence-wrp f-wrp">
                <div className='map-main-wrp f-wrp'>
                    <span className='map-img'>
                        <SVGIcons.MapBG />
                        {/* <MapComponent /> */}
                    </span>
                    <div className='map-con-wrp f-wrp'>
                        <p>{translateThis('Place the cursor over each continent to see where we operate')}</p>
                        <h1>{translateThis('Global')} <b>{translateThis('presence')}</b></h1>
                    </div>
                </div>

                <div className='global-impact-wrp f-wrp'>
                    <div className='container'>
                        <div className='global-impact-box f-wrp'>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div className='impact-con-box f-wrp'>
                                        <h1>{translateThis('Join us for')} <b>{translateThis('global impact')}</b></h1>
                                        <p>{translateThis('impactConPara')}</p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <div className='impact-con-list f-wrp'>
                                        <ul>
                                            {impactConList.map((element, key) => (
                                                <li key={key}>
                                                    <span className='impact-icon'>{element.icon}</span>
                                                    <p>{translateThis((element.title))}</p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='global-contact-wrp contact-main-wrp f-wrp'>
                    <div className='gContact-container contact-main-container'>
                        <div className='global-impact-box f-wrp'>
                            <div className="row">
                                <div className="col-lg-7 col-md-5 col-sm-12 col-xs-12">
                                    <div className='global-contact-img f-wrp'>
                                        <span><img src={AppIcons.globalPresence} alt='global Presence' /></span>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-7 col-sm-12 col-xs-12">
                                    <div className='contact-form-wrp f-wrp'>
                                        <ContactForm />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default GlobalPresence;